import { useForm } from 'react-hook-form';
import { VirtualMedicine } from '../../../apis/virtual-medicines/types';

const useVirtualMedicineForm = (defaultValues?: Partial<VirtualMedicine> | null) => {
  return useForm<VirtualMedicine>({
    defaultValues: defaultValues || {}
  });
};

export default useVirtualMedicineForm;
